<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            new fields.Input({
              label: 'Informacje',
              type: 'textarea',
              modelPath: [this, 'form', 'info'],
              required: true
            }),
            {
              component: 'h3',
              innerText: 'Osoby'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['position']),
                fields: [
                  new fields.Input({
                    label: 'Stanowisko',
                    modelPath: [this, 'form', 'items', i, 'position'],
                    required: true
                  }),
                  new fields.Input({
                    label: 'Informacje',
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'info'],
                    required: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
